<template>
  <span :class="['c-product-card-price', type, { narrow }]"
    >¥<strong>{{ priceText }}</strong>
    <span class="c-product-card-price__meta">&thinsp;税込</span>
  </span>
</template>

<script>
export default {
  name: 'ComponentProductCardPrice',
  props: {
    narrow: { type: Boolean, default: false },
    priceText: { type: String, default: '0' },
    type: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/reset-new';
@use '~/scss/generic/variables';
@use '~/scss/generic/mixins';

.c-product-card-price {
  color: variables.$color-accent;

  @include mixins.screen-mobile {
    font-size: 10px;
  }

  strong {
    font-size: 24px;
    font-weight: normal;
    @include mixins.screen-mobile {
      font-size: 20px;
    }
  }

  & + & {
    margin-left: 4px;
  }

  &.sale {
    color: variables.$color-red;

    strong {
      font-weight: 700;
    }
  }

  &.strikethrough {
    color: variables.$color-text-gray;
    font-size: 8px;
    text-decoration: line-through;
    position: relative;

    @include mixins.screen-mobile {
      font-size: 6px;
    }

    strong {
      font-size: 12px;

      @include mixins.screen-mobile {
        font-size: 8px;
      }
    }
  }

  &.narrow {
    letter-spacing: -0.3px;
    font-size: 10px;
    line-height: 1.15;

    > strong {
      font-size: 16px;
    }
  }

  &__meta {
    display: inline-block;
  }

  &.narrow &__meta {
    font-weight: 300;
    line-height: 1.5;
  }
}
</style>
